import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router'
import { Button } from "../index";
import classNames from "classnames";
import styles from "../../../logic/components/Navigation/Navigation.module.scss";

type PropsType = {
  to: string;
  className?: string;
  children: React.ReactNode;
  onClick: (e: React.MouseEvent) => void;
}

const ButtonLink = (props: PropsType & RouteComponentProps) => {
  return (
      <Button
        type={Button.Types.Button}
        variant={Button.Variants.Transparent}
        classNames={classNames(styles.button, props.className)}
        onClick={(event) => {
          props.onClick && props.onClick(event)
          props.history.push(props.to)
        }}
      >
        {props.children}
      </Button>
  )
}

export default withRouter(ButtonLink);